import React from "react";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { useData } from "../../../components/firebase/DataProvider";

function DialogAlamatTersimpan({
  openTesimpan,
  addToCart,
  closeTersimpan,
  submitting,
}) {
  const { alamat, profil } = useData();
  return (
    <Dialog
      open={openTesimpan}
      onClose={closeTersimpan}
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={closeTersimpan}
            style={{ marginRight: 15 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography>Pilih Alamat Tersimpan</Typography>
        </div>
      </DialogTitle>
      <DialogContent dividers style={{ padding: 0 }}>
        <List style={{ padding: 0 }}>
          {alamat?.length > 0 ? (
            alamat?.map((item) => {
              return (
                <>
                  <ListItem
                    button
                    onClick={() => addToCart(item)}
                    disabled={submitting}
                  >
                    <ListItemText
                      primary={
                        <>
                          <Typography
                            // component="span"
                            // variant="body2"
                            style={{ display: "inline" }}
                            // className={classes.inline}
                            color="textPrimary"
                          >
                            {item.nama_penerima}
                          </Typography>
                          <Typography
                            // component="span"
                            variant="p"
                            style={{ display: "inline" }}
                            // className={classes.inline}
                            color="primary"
                          >
                            {"     "}{" "}
                            {profil?.alamat_utama === item.id ? "(Utama)" : ""}
                          </Typography>
                        </>

                        //`${item.judul} - ${item.nama_penerima}`
                      }
                      secondary={`${item.alamat_lengkap}, ${item.kelurahan.name}, ${item.kecamatan.name}, ${item.kota.name}, ${item.provinsi.name}`}
                    />
                  </ListItem>
                  <Divider />
                </>
              );
            })
          ) : (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "40%",
              }}
            >
              <p>
                <b>Tidak Ada Alamat Tersimpan</b>
              </p>
            </div>
          )}
        </List>
        {/* <Gap height={50} /> */}
      </DialogContent>
    </Dialog>
  );
}

export default DialogAlamatTersimpan;
